import { DocumentFileLine } from '@hourly-hds/icons/glyph';
import { ReactNode } from 'react';
import styles from './File.module.css';

type FileData = {
  id: string;
  name: string;
  label: string;
  size: string;
};

type FileProps = {
  data: FileData;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
};

const File = ({
  data,
  primaryAction: PrimaryAction,
  secondaryAction: SecondaryAction,
}: FileProps) => (
  <div className={styles.container}>
    <div className={styles.iconContainer}>
      <DocumentFileLine />
    </div>
    <div className={styles.infoContainer}>
      <p className={styles.fileLabel}>{data.label}</p>
      <p className={styles.fileName}>{data.name}</p>
      <p className={styles.fileSize}>{data.size}</p>
    </div>
    <div className={styles.actions}>
      {PrimaryAction}
      {SecondaryAction}
    </div>
  </div>
);

export default File;
